export const LinguistHeaderKey = 'x-wix-linguist';

interface Params {
  locale: string; // e.g. 'ru'
  lang: string; // e.g. 'ru-ru'
  isPrimaryLanguage: boolean;
  appInstanceId: string;
}

export const buildLinguistHeader = (params: Params) =>
  [
    params.locale,
    params.lang,
    params.isPrimaryLanguage,
    params.appInstanceId,
  ].join('|');
